module.exports = __webpack_public_path__ + "static/img/麗京棧.17e7cd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/麗京棧.png?20181011
// module id = ko2r
// module chunks = 1